import Amplify from 'aws-amplify';

Amplify.configure({
  Auth: {
    // フェデレーションアイデンティティのID
    identityPoolId: 'ap-northeast-1:dc6be354-9e90-41ef-ba06-e69d0d1c67b6',
    // リージョン
    region: 'ap-northeast-1',
    // ユーザープールのID
    userPoolId: 'ap-northeast-1_DsaRIRHZO',
    // ユーザープールのウェブクライアントID
    userPoolWebClientId: 'opda9pb0tgoaf9vshr1s3181a',
    mandatorySignIn: true,
  },
  Storage: {
    bucket: 'yoshino-cognito', //使用するS3バケット名
    region: 'ap-northeast-1', //リージョン
  },
});